import useSWR from "swr";
import { fetcher } from "lib/actions/fetcher";
import { SpeckleAccount } from "lib/types/speckle/SpeckleAccount";
import { endpointsSpeckle } from "components/modules/UploadDialog/lib/actions/endpointsSpeckle";

export const useSpeckleAccounts = () => {
  const {
    data: accounts,
    error,
    mutate,
  } = useSWR<SpeckleAccount[]>(endpointsSpeckle.accounts, fetcher);

  return {
    accounts: accounts,
    isLoading: !accounts && !error,
    hasError: !!error,
  };
};
